var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"footer-content"}},[_c('FooterTop'),_vm._v(" "),_c('FooterNav'),_vm._v(" "),_c('FooterBottom')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }